<template>
  <div class="home-wrapper">
    <!-- 顶部 -->
    <header class="app-header">
      <div class="brand">
        <div class="brand-mark">
          <svg viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 4 L29 8 L29 18 C29 25 18 31 18 31 C18 31 7 25 7 18 L7 8 Z"
                  stroke="currentColor" stroke-width="1.4" stroke-linejoin="round" fill="none"/>
            <path d="M11 18 H14 L16 14 L20 22 L22 18 H25"
                  stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
          </svg>
        </div>
        <div class="brand-text">
          <div class="brand-name">脉钥健康</div>
          <div class="brand-sub">MAIYUE HEALTH</div>
        </div>
      </div>

      <div class="user-area">
        <span class="user-org" v-if="hospitalName">{{ hospitalName }}</span>
        <button class="user-avatar" @click="personalCenter" :title="loginInfo.username || ''">
          <span>{{ avatarInitial }}</span>
        </button>
        <button class="quit-btn" @click="quit" title="退出登录">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
        </button>
      </div>
    </header>

    <div class="main" :style="{ height: mainH }">
      <!-- 左侧导航 -->
      <nav class="side-nav">
        <ul class="nav-list">
          <li
            v-for="(item, leftMenuIndex) in mainRoutes"
            :key="leftMenuIndex"
            v-show="item.show"
            class="nav-item"
            :class="{ active: leftMenuIndex == currentLeftMenuIndex }"
            @click.stop="goLeftMenuRouter(item.url, leftMenuIndex)"
            @mouseenter="enter(leftMenuIndex, item)"
            @mouseleave="leave(leftMenuIndex, item)"
          >
            <div class="nav-icon">
              <svg v-if="item.icon === 'shop'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 7h18l-1.4 11.7A2 2 0 0 1 17.6 20.5H6.4a2 2 0 0 1-2-1.8L3 7z"/>
                <path d="M8 7V5a4 4 0 0 1 8 0v2"/>
              </svg>
              <svg v-else-if="item.icon === 'chart'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="20" x2="18" y2="10"/>
                <line x1="12" y1="20" x2="12" y2="4"/>
                <line x1="6" y1="20" x2="6" y2="14"/>
              </svg>
              <svg v-else-if="item.icon === 'user'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2"/>
                <circle cx="10" cy="7" r="4"/>
                <path d="M21 21v-2a4 4 0 0 0-3-3.87"/>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
              <svg v-else-if="item.icon === 'settings'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="3"/>
                <path d="M19.4 15a1.65 1.65 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.65 1.65 0 0 0-1.8-.3 1.65 1.65 0 0 0-1 1.5V21a2 2 0 0 1-4 0v-.1a1.65 1.65 0 0 0-1.1-1.5 1.65 1.65 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.65 1.65 0 0 0 .3-1.8 1.65 1.65 0 0 0-1.5-1H3a2 2 0 0 1 0-4h.1A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.65 1.65 0 0 0 1.8.3H9a1.65 1.65 0 0 0 1-1.5V3a2 2 0 0 1 4 0v.1a1.65 1.65 0 0 0 1 1.5 1.65 1.65 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.65 1.65 0 0 0-.3 1.8V9a1.65 1.65 0 0 0 1.5 1H21a2 2 0 0 1 0 4h-.1a1.65 1.65 0 0 0-1.5 1z"/>
              </svg>
              <svg v-else-if="item.icon === 'book'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
              </svg>
              <svg v-else-if="item.icon === 'file'" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                <polyline points="14 2 14 8 20 8"/>
                <line x1="9" y1="13" x2="15" y2="13"/>
                <line x1="9" y1="17" x2="13" y2="17"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <span class="nav-label">{{ item.menuName }}</span>

            <ul
              v-if="item.tabList.length > 1 && hoveredMenuIndex === item.index"
              class="sub-menu"
              @mouseenter="keepHover"
              @mouseleave="leave"
            >
              <li
                v-for="(sub, subIdx) in item.tabList"
                :key="subIdx"
                :class="{ active: item.currentSubIndex === subIdx }"
                @click.stop="onSubTabClick(item, subIdx)"
              >{{ sub }}</li>
            </ul>
          </li>
        </ul>
      </nav>

      <!-- 右侧主内容 -->
      <main class="content">
        <router-view v-slot="{ Component }">
          <keep-alive>
            <component :is="Component" :key="$route.name" v-if="$route.meta.keepAlive" />
          </keep-alive>
          <component :is="Component" :key="$route.name" v-if="!$route.meta.keepAlive" />
        </router-view>
      </main>
    </div>
  </div>
</template>

<script>
  import config from "../../../package.json";
  import {
    reactive,
    toRefs,
    onMounted,
    nextTick,
    computed
  } from 'vue';
  import {
    useRouter,
    useRoute
  } from "vue-router";

  export default {
    setup() {
      const router = useRouter();
      const route = useRoute();
      const data = reactive({
        version: config.version,
        mainH: 100,
        currentLeftMenuIndex: 0,
        isMeasurement: false,
        mainRoutes: [
          {
            menuName: "商城管理",
            icon: 'shop',
            url: "/mallManagement/dashboard",
            show: true,
            tabList: ["统计看板", "商品管理", "会员管理", "代理邀请", "订单管理", "提现审批", "佣金配置", "会员充值", "平台账户", "城代审批"],
            subRoutes: [
              "/mallManagement/dashboard",
              "/mallManagement/productManage",
              "/mallManagement/memberManage",
              "/mallManagement/adminInvite",
              "/mallManagement/orderManage",
              "/mallManagement/withdrawalManage",
              "/mallManagement/commissionConfig",
              "/mallManagement/rechargeManage",
              "/mallManagement/platformAccount",
              "/mallManagement/cityAgentApplyManage",
            ],
            currentSubIndex: 0,
            index: 0,
          },
          {
            menuName: "报告管理",
            icon: 'chart',
            url: "/historyList/reportOverview",
            show: true,
            tabList: ["平台查看", "机构查询"],
            subRoutes: [
              "/historyList/reportOverview",
              () => data.role == 1 ? "/historyList/reportHos" : "/historyList/historyList",
            ],
            currentSubIndex: 0,
            index: 1,
          },
          {
            menuName: "用户管理",
            icon: 'user',
            url: "/userManagement/accountList",
            show: true,
            tabList: ["账号管理"],
            subRoutes: [
              "/userManagement/accountList",
            ],
            currentSubIndex: 0,
            index: 2,
          },
          {
            menuName: "基础设置",
            icon: 'settings',
            url: "/basicSetting/tongueInterpretation",
            show: true,
            tabList: ["舌面释义", "报告结果", "规则设置", "养生方案"],
            subRoutes: [
              "/basicSetting/tongueInterpretation",
              "/basicSetting/reportResult",
              "/basicSetting/ruleSetting",
              "/basicSetting/healthPlan",
            ],
            currentSubIndex: 0,
            index: 3,
          },
          {
            menuName: "知识库管理",
            icon: 'book',
            url: "/knowledgeManagement/dietRecommend",
            show: true,
            tabList: ["饮食推荐", "体质管理", "选项维护", "健康评估", "穴位维护", "运动健康", "药食管理", "图片管理", "视频管理"],
            subRoutes: [
              "/knowledgeManagement/dietRecommend",
              "/knowledgeManagement/constituteManagement",
              "/knowledgeManagement/optionManagement",
              "/knowledgeManagement/healthAssessment",
              "/knowledgeManagement/physiothMainten",
              "/knowledgeManagement/sportsHealth",
              "/knowledgeManagement/drugManagement",
              "/knowledgeManagement/picManagement",
              "/knowledgeManagement/videoManagement",
            ],
            currentSubIndex: 0,
            index: 4,
          },
          {
            menuName: "内容管理",
            icon: 'file',
            url: "/contentManagement/homeManage",
            show: true,
            tabList: ["首页管理", "关于我们", "产品资质"],
            subRoutes: [
              "/contentManagement/homeManage",
              "/contentManagement/aboutManage",
              "/contentManagement/qualificationManage",
            ],
            currentSubIndex: 0,
            index: 5,
          },
          {
            menuName: "个人中心",
            icon: 'profile',
            url: "/personalCenter/personalCenter",
            show: true,
            tabList: ["个人信息", "修改密码"],
            subRoutes: [
              "/personalCenter/personalCenter",
              "/personalCenter/modifyPassword",
            ],
            currentSubIndex: 0,
            index: 6,
          },
        ],
        hoveredMenuIndex: -1,
        tabActiveIndex: 0,
        loginInfo: {},
        role: "",
        hospitalName: "",
      });

      const avatarInitial = computed(() => {
        const name = (data.loginInfo && (data.loginInfo.username || data.loginInfo.realname || data.loginInfo.name)) || ''
        const ch = name.toString().charAt(0).toUpperCase()
        return ch || '?'
      })

      const initHeight = () => {
        const stored = sessionStorage.getItem("currentLeftMenuIndex");
        if (stored !== null) data.currentLeftMenuIndex = Number(stored);
        data.mainH = (window.innerHeight - 64) + "px";
      }

      const goLeftMenuRouter = (url, index) => {
        if (data.isMeasurement) return;
        data.currentLeftMenuIndex = index;
        sessionStorage.setItem("currentLeftMenuIndex", index);
        const menu = data.mainRoutes.find(m => m.index === index);
        if (menu) menu.currentSubIndex = 0;
        router.push({ path: url });
      }

      const quit = () => {
        if (data.isMeasurement) return false;
        router.push({ path: "/login/login" });
      }

      const onSubTabClick = (menuItem, subIndex) => {
        menuItem.currentSubIndex = subIndex;
        data.currentLeftMenuIndex = menuItem.index;
        sessionStorage.setItem("currentLeftMenuIndex", menuItem.index);
        const r = menuItem.subRoutes[subIndex];
        const path = typeof r === 'function' ? r() : r;
        if (path) router.push({ path });
      }

      const personalCenter = () => {
        if (data.tabActiveIndex == 0) {
          router.push({ path: "/personalCenter/personalCenter" });
        }
        data.currentLeftMenuIndex = 6;
      }

      let hoverTimer = null
      const enter = (index, item) => {
        if (data.isMeasurement) return;
        if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
        data.hoveredMenuIndex = item.index;
      }

      const leave = () => {
        if (hoverTimer) clearTimeout(hoverTimer);
        hoverTimer = setTimeout(() => {
          data.hoveredMenuIndex = -1;
          hoverTimer = null;
        }, 220);
      }

      const keepHover = () => {
        if (hoverTimer) { clearTimeout(hoverTimer); hoverTimer = null; }
      }

      const measurement = (item) => {
        data.isMeasurement = item === true;
      }

      onMounted(() => {
        nextTick(() => {
          data.tabActiveIndex = localStorage.getItem("tabActiveIndex");
          const raw = localStorage.getItem("loginInfo");
          if (raw) {
            data.loginInfo = JSON.parse(raw) || {};
            data.role = data.loginInfo.role;
          }
          if (data.tabActiveIndex == 1) {
            data.hospitalName = localStorage.getItem("hospitalName");
            data.mainRoutes[data.mainRoutes.length - 1].show = false;
          } else {
            data.hospitalName = data.loginInfo.hospitalName || '';
          }
          initHeight();
          window.addEventListener('resize', initHeight);
          const navEl = document.getElementById('nav');
          if (navEl) navEl.style.display = "none";
        })
      });

      return {
        ...toRefs(data),
        avatarInitial,
        goLeftMenuRouter,
        quit,
        onSubTabClick,
        personalCenter,
        enter,
        leave,
        keepHover,
        measurement,
      };
    },
  }
</script>

<style lang="less" scoped>
  // ── Design Tokens ──
  @primary-50:  #E6F7F5;
  @primary-100: #C2EDE7;
  @primary-300: #5CCABD;
  @primary-500: #2EAD9E;
  @primary-600: #258F83;
  @primary-700: #1D7268;
  @primary-800: #15544D;

  @gray-0:   #FFFFFF;
  @gray-50:  #FAFAF8;
  @gray-100: #F4F3F0;
  @gray-200: #E8E6E1;
  @gray-300: #DAD7D0;
  @gray-400: #B0ADA6;
  @gray-500: #8A8780;
  @gray-700: #4D4A43;
  @gray-800: #33312B;

  @font-display: 'Noto Serif SC', 'SimSun', serif;
  @font-body:    'Noto Sans SC', 'Microsoft YaHei', sans-serif;

  .home-wrapper {
    width: 100%;
    height: 100%;
    background: @gray-50;
    font-family: @font-body;
    color: @gray-800;
  }

  /* ─── 顶部导航 ─── */
  .app-header {
    position: relative;
    height: 64px;
    background: @primary-700;
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .brand {
    display: flex;
    align-items: center;
    gap: 14px;
    .brand-mark {
      width: 36px;
      height: 36px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      svg { width: 100%; height: 100%; }
    }
    .brand-text {
      .brand-name {
        font-family: @font-display;
        font-size: 18px;
        font-weight: 600;
        color: #fff;
        letter-spacing: 4px;
        line-height: 1.1;
      }
      .brand-sub {
        font-size: 11px;
        color: rgba(255, 255, 255, 0.65);
        letter-spacing: 4px;
        margin-top: 4px;
      }
    }
  }

  .user-area {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .user-org {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.78);
    letter-spacing: 0.5px;
    max-width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .user-avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 1px solid rgba(255, 255, 255, 0.4);
    background: transparent;
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 200ms ease, border-color 200ms ease;
    &:hover {
      background: rgba(255, 255, 255, 0.12);
      border-color: rgba(255, 255, 255, 0.7);
    }
  }
  .quit-btn {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    border: none;
    background: transparent;
    color: rgba(255, 255, 255, 0.78);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 150ms ease, background 150ms ease;
    svg { width: 16px; height: 16px; }
    &:hover {
      color: #fff;
      background: rgba(255, 255, 255, 0.12);
    }
  }

  /* ─── 主体 ─── */
  .main {
    display: flex;
    width: 100%;
  }

  /* ─── 左侧导航 ─── */
  .side-nav {
    position: relative;
    flex: 0 0 96px;
    background: @gray-0;
    border-right: 1px solid @gray-200;
    overflow: visible;
    padding: 12px 0;
    /* 抬高整条侧栏的层叠：二级飞出菜单被困在本栈内（z:99 相对于侧栏），
       而页面内容里 el-table 单元格 z:1、el-tabs 头部 z:2 等会与原 z:2 打平/胜出，
       导致飞出菜单展开时被页面元素穿透。提到 100 确保飞出层始终盖住页面内容
       （Element Plus 弹窗/下拉用 2000+，不受影响）。 */
    z-index: 100;
  }
  .nav-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .nav-item {
    position: relative;
    padding: 14px 8px;
    margin: 4px 8px;
    border-radius: 10px;
    cursor: pointer;
    text-align: center;
    color: @gray-500;
    transition: color 150ms ease, background 150ms ease;

    .nav-icon {
      width: 28px;
      height: 28px;
      margin: 0 auto 6px;
      svg { width: 100%; height: 100%; }
    }
    .nav-label {
      display: block;
      font-size: 12px;
      letter-spacing: 0.5px;
      line-height: 1.3;
    }

    &:hover {
      color: @primary-600;
      background: @primary-50;
    }
    &.active {
      color: @primary-700;
      background: @primary-100;
      &::before {
        content: '';
        position: absolute;
        left: -8px;
        top: 10px;
        bottom: 10px;
        width: 3px;
        background: @primary-500;
        border-radius: 0 3px 3px 0;
      }
      .nav-icon { color: @primary-600; }
      .nav-label {
        color: @primary-700;
        font-weight: 500;
      }
    }
  }

  /* ─── 二级菜单浮层 ─── */
  .sub-menu {
    position: absolute;
    list-style: none;
    margin: 0;
    padding: 6px;
    left: calc(100% + 8px);
    top: -4px;
    min-width: 148px;
    background: @gray-0;
    border: 1px solid @gray-200;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(53, 51, 45, 0.10);
    z-index: 99;
    text-align: left;
    animation: subMenuIn 160ms ease-out;

    /* 与 nav-item 之间的透明桥接区，避免鼠标穿越 gap 时丢 hover */
    &::before {
      content: '';
      position: absolute;
      left: -10px;
      top: 0;
      bottom: 0;
      width: 12px;
    }
    /* 左侧 teal 指示三角 */
    &::after {
      content: '';
      position: absolute;
      left: -5px;
      top: 18px;
      width: 8px;
      height: 8px;
      background: @gray-0;
      border-left: 1px solid @gray-200;
      border-bottom: 1px solid @gray-200;
      transform: rotate(45deg);
    }

    li {
      position: relative;
      padding: 9px 14px;
      font-size: 13px;
      color: @gray-700;
      letter-spacing: 0.5px;
      border-radius: 8px;
      cursor: pointer;
      transition: color 150ms ease, background 150ms ease, padding-left 150ms ease;
      white-space: nowrap;

      &:hover {
        color: @primary-700;
        background: @primary-50;
        padding-left: 18px;
      }
      &.active {
        color: @primary-700;
        background: @primary-100;
        font-weight: 500;
        &::before {
          content: '';
          position: absolute;
          left: 4px;
          top: 50%;
          transform: translateY(-50%);
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background: @primary-500;
        }
      }
    }
  }

  @keyframes subMenuIn {
    from { opacity: 0; transform: translateX(-4px); }
    to   { opacity: 1; transform: translateX(0); }
  }

  /* ─── 右侧内容 ─── */
  .content {
    position: relative;
    flex: 1;
    overflow: hidden;
    background: @gray-50;
    display: flex;
    flex-direction: column;
    > * { flex: 1; min-height: 0; }
  }
</style>
